export default __webpack_public_path__ + "static/media/O_Forms.07d9875d.png";